import { EventEmitter } from "events";
import { ContainerModule, interfaces } from "inversify";
import { eventEmitterRTTI } from "./events.rtti";
import { Emitter } from "./EventPublisher/Emitter";

export const eventsModuleContainer = new ContainerModule((bind: interfaces.Bind) => {
    bind<Emitter>(eventEmitterRTTI).toDynamicValue(() => new EventEmitter());
});
